// extracted by mini-css-extract-plugin
export var box = "_9k-1";
export var checkboxRow = "_9k-8";
export var checked = "_9k-2";
export var descriptionSpacer = "_9k-a";
export var disabled = "_9k-3";
export var icon = "_9k-6";
export var input = "_9k-0";
export var labelSpacer = "_9k-9";
export var medium = "_9k-5";
export var small = "_9k-4";
export var text = "_9k-7";